import React from 'react';
import './Container.scss';

const Container = ({ children }) => <div className="Container">{children}</div>;

export default Container;